import React, { useState } from "react"
import styled from "styled-components"
import { Button } from "../../reusableComponents/Button"
import ImgLeftSmall from "../../../assets/images/banner-accent-small-left.svg"
import ImgRightSmall from "../../../assets/images/banner-accent-small-right.svg"
import Person from "../../../assets/images/person.png"

const Banner = () => {
  const [collapsed, setCollapsed] = useState(false)

  const toggleCollapse = () => {
    setCollapsed(prev => !prev)
    console.log("hello world")
  }

  const downloadPDF = () => {
    const link = document.createElement("a")
    link.href = "/pdf/referral-program.pdf"
    link.download = "referral-program.pdf"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Container $collapsed={collapsed}>
      <AccentLeftSmall $collapsed={collapsed}>
        <Image src={ImgLeftSmall}></Image>
      </AccentLeftSmall>
      <AccentRightSmall $collapsed={collapsed}>
        <Image src={ImgRightSmall}></Image>
      </AccentRightSmall>
      {collapsed && (
        <PersonContainer>
          <Image src={Person} />
        </PersonContainer>
      )}

      <Wrapper $collapsed={collapsed}>
        {collapsed && (
          <Paragraph>We’re excited to announce the launch of the </Paragraph>
        )}

        <HeaderFont $collapsed={collapsed}>
          Writers Way Solutions Author{collapsed && <br />} Referral Program
        </HeaderFont>
        {collapsed && (
          <Paragraph>
            This referral program is designed to help drive new client
            acquisitions while rewarding authors for successful referrals. This
            program provides sales with an additional option for encouraging
            organic referrals and converting warm leads into new signups. 
          </Paragraph>
        )}

        {collapsed ? (
          <ButtonWrapper>
            <Button
              to="#"
              onClick={e => {
                e.preventDefault()
                downloadPDF()
              }}
              round="true"
              small
            >
              View reward options
            </Button>

            <Button
              to="#"
              onClick={e => {
                e.preventDefault()
                toggleCollapse()
              }}
              round="true"
              small
            >
              See less
            </Button>
          </ButtonWrapper>
        ) : (
          <Button
            to="#"
            onClick={e => {
              e.preventDefault()
              toggleCollapse()
            }}
            round="true"
            small
          >
            Learn more
          </Button>
        )}
      </Wrapper>
    </Container>
  )
}

export default Banner

const Container = styled.div`
  width: 100%;
  min-height: 80px;
  height: ${({ $collapsed }) => ($collapsed ? "467px" : "80px")};
  background: linear-gradient(90deg, #ffffff 26%, #e3f9ff 77%);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  position: relative;
  overflow: hidden;
  transition: height 0.3s ease;

  @media screen and (max-width: 1200px) {
    height: auto;
  }
`

const Wrapper = styled.div`
  height: 100%;
  width: ${({ $collapsed }) => ($collapsed ? "37%" : "auto")};
  display: flex;
  flex-direction: ${({ $collapsed }) => ($collapsed ? "column" : "row")};
  justify-content: center;
  align-items: ${({ $collapsed }) => ($collapsed ? "flex-start" : "center")};
  gap: 16px;
  position: relative;
  z-index: 3;

  @media screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 30px 0;
    gap: 12px;
  }

  @media screen and (max-width: 900px) {
    width: auto;
    padding: 30px 20px;
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
`

const AccentLeftSmall = styled.div`
  position: absolute;
  left: -50px;
  bottom: ${({ $collapsed }) => ($collapsed ? "-50px" : "0")};
  width: ${({ $collapsed }) => ($collapsed ? "440px" : "164px")};
  height: 100%;
  z-index: 1;

  @media screen and (max-width: 1200px) {
    left: ${({ $collapsed }) => ($collapsed ? "-10%" : "-5%")};
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`

const AccentRightSmall = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: auto;
  height: 100%;
  z-index: 1;

  @media screen and (max-width: 1200px) {
    right: ${({ $collapsed }) => ($collapsed ? "-15%" : "-5%")};
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`

const PersonContainer = styled.div`
  height: 100%;
  widht 400px;

  @media screen and (max-width: 900px) {
   display: none;
  }
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  z-index: 2;
`

const HeaderFont = styled.h1`
  color: ${props => props.theme.colors.accent7};
  font-size: ${({ $collapsed }) => ($collapsed ? "45px" : "34px")};

  @media screen and (max-width: 1100px) {
    font-size: 25px;
  }

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`

const Paragraph = styled.p`
  font-size: 16px;
  color: #1e1e1e;
  line-height: 25px;

  @media screen and (max-width: 1100px) {
    font-size: 12px;
    line-height: 20px;
  }
`
